import React, { Component } from 'react';

import config from '../../../config';
import AnalyticsActionCreator from '../../../actions/AnalyticsActionCreator';
import SwipeableViews from 'react-swipeable-views';
import bindKeyboard from 'react-swipeable-views/lib/bindKeyboard';
import { ProjectionPagination } from './ProjectionPagination';
import { ProjectionDemoGo } from './ProjectionDemoGo';
import FinancialStoriesActionCreator from '../../../actions/FinancialStoriesActionCreator';
import InternetBankingActions from '../../../actions/InternetBankingActions';
import BrowserUtils from '../../../utils/BrowserUtils';
import _ from 'lodash';
import PropTypes from 'prop-types';

const AutoPlaySwipeableViews = bindKeyboard(SwipeableViews);

const styles = {
  slide: {
    padding: 15,
    paddingTop: 0,
    minHeight: 500,
    color: '#57575f',
    fontSize: '23px',
    textAlign: 'center',
    paddingBottom: '50px',
  },

  slideGreen: {
    padding: 15,
    paddingTop: 0,
    minHeight: 500,
    color: '#57575f',
    fontSize: '23px',
    textAlign: 'center',
    paddingBottom: '50px',
  },

  mobilesSlide: {
    padding: 15,
    minHeight: 500,
    color: '#57575f',
    fontSize: '23px',
    background: '#f8f8f8',
    textAlign: 'center',
    paddingBottom: '50px',
  },

  img: {
    width: 973,
  },
};

/**
 * @todo
 * This component is of poor quality.
 * Future improvement work should be done to raise the standard and increased
 * the health of the codebase.
 */
class ProjectionTourComponent extends Component {
  constructor(props) {
    super(props);

    this.demoText = this.demoText.bind(this);
    this.swipeLeft = this.swipeLeft.bind(this);
    this.swipeRight = this.swipeRight.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
    this.closed = this.closed.bind(this);
    this.isMobileDevice = this.isMobileDevice.bind(this);
    this.disabledIcon = this.disabledIcon.bind(this);
    this.changeBackgroundFluidFull = this.changeBackgroundFluidFull.bind(this);
    this.changeBackgroundGutters = this.changeBackgroundGutters.bind(this);
    this.disabledRightIcon = this.disabledRightIcon.bind(this);
    this.disabledLeftIcon = this.disabledLeftIcon.bind(this);
    this.renderHelpDemoWeb = this.renderHelpDemoWeb.bind(this);
    this.renderHelpDomeMobile = this.renderHelpDomeMobile.bind(this);
    this.renderHelpDemoPages = this.renderHelpDemoPages.bind(this);
    this.backToProjection = this.backToProjection.bind(this);

    this.state = {
      index: 0,
      Go: false,
    };
  }

  // To get the text under every image.
  demoText(index) {
    if (this.isMobileDevice()) {
      const demoMsg = [];
      return demoMsg[index];
    } else {
      const demoMsg = [
        'Projections Quick Tour',
        'Projections Quick Tour',
        'Projections Quick Tour',
        'Projections Quick Tour',
        'Projections Quick Tour',
      ];
      return demoMsg[index];
    }
  }

  // Demo images will be moved left side.
  swipeLeft() {
    if (this.state.index > 0) {
      this.setState({ index: this.state.index - 1 });
    }
  }

  // Demo images will be moved right side.
  swipeRight() {
    const index = this.isMobileDevice() ? 5 : 5;
    if (this.state.index === index) {
      this.setState({ Go: true });
    } else {
      this.setState({
        index: this.state.index + 1,
      });
    }
  }

  // On click change the index of dot.
  handleChangeIndex(index) {
    this.setState({
      index,
    });
  }

  closed() {
    this.setState({ Go: false });
  }

  isMobileDevice() {
    return BrowserUtils.isMobileView();
  }

  disabledIcon() {
    if (this.state.index === 0) {
      return 'icon icon-page-back icon-arrow-disabled';
    } else {
      return 'icon icon-page-back';
    }
  }

  changeBackgroundFluidFull() {
    if (this.state.index === 5) {
      return 'col-lg-12 col-md-12 demo-content greenBackground';
    } else {
      return 'col-lg-12 col-md-12 demo-content';
    }
  }

  changeBackgroundGutters() {
    if (this.state.index === 5) {
      return 'row no-gutters demo-header greenBackground';
    } else {
      return 'row no-gutters demo-header';
    }
  }

  disabledRightIcon() {
    if (this.state.index === 5) {
      return 'icon icon-page-next icon-arrow-disabled';
    } else {
      return 'icon icon-page-next';
    }
  }

  disabledLeftIcon() {
    if (this.state.index === 0) {
      return 'icon icon-page-back icon-arrow-disabled';
    } else if (this.state.index === 5) {
      return 'icon icon-page-back whiteArrow';
    } else {
      return 'icon icon-page-back';
    }
  }

  renderHelpDemoWeb() {
    return (
      <div className={this.changeBackgroundFluidFull()}>
        <a className={this.disabledLeftIcon()} onClick={this.swipeLeft} />
        <AutoPlaySwipeableViews
          index={this.state.index}
          onChangeIndex={this.handleChangeIndex}
        >
          <div
            className="slide"
            style={_.assign({}, styles.slide, styles.slide3)}
          >
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/Toggle.png"
              alt=""
              title=""
            />
            <p style={{ fontSize: '20px' }}>
              {this.props.content.TutorialProjectionsslide1Text}
            </p>
          </div>
          <div
            className="slide"
            style={_.assign({}, styles.slide, styles.slide3)}
          >
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/DD-SO.png"
              alt=""
              title=""
            />
            <p style={{ fontSize: '20px' }}>
              {this.props.content.TutorialProjectionsslide2Text}
            </p>
          </div>

          <div
            className="slide"
            style={_.assign({}, styles.slide, styles.slide3)}
          >
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/Toggle-Tags.png"
              alt=""
              title=""
            />
            <p style={{ fontSize: '20px' }}>
              {this.props.content.TutorialProjectionsslide3Text}
            </p>
          </div>
          <div
            className="slide"
            style={_.assign({}, styles.slide, styles.slide3)}
          >
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/Projections.png"
              alt=""
              title=""
            />
            <p style={{ fontSize: '20px' }}>
              {this.props.content.TutorialProjectionsslide4Text}
            </p>
          </div>
          <div
            className="slide"
            style={_.assign({}, styles.slide, styles.slide3)}
          >
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/projection_tour_wheel.png"
              alt=""
              title=""
            />
            <p style={{ fontSize: '20px' }}>
              {this.props.content.TutorialProjectionsslide5Text}
            </p>
          </div>
          <div
            className="slide"
            style={_.assign({}, styles.slide, styles.slideGreen)}
          >
            <ProjectionDemoGo {...this.props} closed={this.props.closed} />
          </div>
        </AutoPlaySwipeableViews>
        <a className={this.disabledRightIcon()} onClick={this.swipeRight} />
        <ProjectionPagination
          dots={6}
          index={this.state.index}
          onChangeIndex={this.handleChangeIndex}
        />
      </div>
    );
  }

  renderHelpDomeMobile() {
    return (
      <div className={this.changeBackgroundFluidFull()}>
        <a className={this.disabledLeftIcon()} onClick={this.swipeLeft} />
        <AutoPlaySwipeableViews
          index={this.state.index}
          onChangeIndex={this.handleChangeIndex}
        >
          <div
            className="slide"
            style={_.assign({}, styles.slide, styles.slide3)}
          >
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/Toggle.png"
              alt=""
              title=""
            />
            <p>
              To start, B will take into account what you've tagged as earnings
            </p>
          </div>
          <div
            className="slide"
            style={_.assign({}, styles.slide, styles.slide3)}
          >
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/DD-SO.png"
              alt=""
              title=""
            />
            <p>
              Review your Commitments; these are Standing Orders and Direct
              Debits on your account
            </p>
          </div>

          <div
            className="slide"
            style={_.assign({}, styles.slide, styles.slide3)}
          >
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/Toggle-Tags.png"
              alt=""
              title=""
            />
            <p>
              Select the tags which are essential to you, and B will incorporate
              the spending on these tags to make your projection more relevant
            </p>
          </div>
          <div
            className="slide"
            style={_.assign({}, styles.slide, styles.slide3)}
          >
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/Projections.png"
              alt=""
              title=""
            />
            <p>
              Look ahead to keep track of projected earnings and commitments,
              and receive alerts if you're going to run low
            </p>
          </div>
          <div
            className="slide"
            style={_.assign({}, styles.slide, styles.slide3)}
          >
            <img
              style={_.assign({}, styles.img)}
              src="../images/b/projection_tour_wheel.png"
              alt=""
              title=""
            />
            <p>
              B will give you a projected discretionary balance (good to go) or
              give you a heads up on when you may be running low
            </p>
          </div>
          <div
            className="slide"
            style={_.assign({}, styles.slide, styles.slideGreen)}
          >
            <ProjectionDemoGo {...this.props} closed={this.props.closed} />
          </div>
        </AutoPlaySwipeableViews>
        <a className={this.disabledRightIcon()} onClick={this.swipeRight} />
        <ProjectionPagination
          dots={6}
          index={this.state.index}
          onChangeIndex={this.handleChangeIndex}
        />
      </div>
    );
  }

  renderHelpDemoPages() {
    if (this.isMobileDevice()) {
      return this.renderHelpDomeMobile();
    } else return this.renderHelpDemoWeb();
  }

  backToProjection() {
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description: config.analytics.analytics_action_projections_demo_back,
        event: 'click',
      }
    );
    FinancialStoriesActionCreator.handleUpdateFSTileClick();
    InternetBankingActions.navigateToWebTask('WEB-OPEN-FINANCIAL_STORIES');
  }

  render() {
    return (
      <div className="demo-page">
        <div className={this.changeBackgroundGutters()}>
          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-3">
            {this.state.index === 5 ? (
              ''
            ) : (
              <div>
                <button
                  className="page-back"
                  onClick={this.props.backButtonOnDemoSettings}
                >
                  <span className="icon icon-page-back" />
                  Back
                </button>
              </div>
            )}
          </div>
          <div className="col-lg-8 col-md-8 col-sm-8 col-xs-6 text-center">
            {this.state.index >= 0 ? (
              <h3>{this.demoText(this.state.index)}</h3>
            ) : (
              <h3>&nbsp; </h3>
            )}
          </div>
          <div className="col-lg-2 col-md-2 8 col-sm-2 col-xs-3 text-right" />
        </div>
        {this.renderHelpDemoPages()}
      </div>
    );
  }
}

ProjectionTourComponent.propTypes = {
  content: PropTypes.object,
  closed: PropTypes.func,
};

export { ProjectionTourComponent };
